export const MODAL_BODY_DISPLAY_NAME = "DashboardModal.Body";
export const MODAL_ACTIONS_DISPLAY_NAME = "DashboardModal.Actions";
export const MODAL_HEADER_DISPLAY_NAME = "DashboardModal.Header";
export const MODAL_PICKER_HEADER_DISPLAY_NAME = "DashboardModal.PickerHeader";
export const MODAL_CONTEXT_HEADER_DISPLAY_NAME = "DashboardModal.ContextHeader";
export const MODAL_DIVIDER_DISPLAY_NAME = "DashboardModal.ModalDivider";

export const MODAL_CHROME_DISPLAY_NAMES = [
  MODAL_HEADER_DISPLAY_NAME,
  MODAL_PICKER_HEADER_DISPLAY_NAME,
  MODAL_CONTEXT_HEADER_DISPLAY_NAME,
] as const;
